<svelte:head>
    <title>Ozzie Collectables - New Shipping Clicker</title>
</svelte:head>


<script>
    import CircularProgress from '@smui/circular-progress';
    import IconButton from '@smui/icon-button';
    import Snackbar, {Actions as SnackbarActions, Label as SnackbarLabel} from '@smui/snackbar';
    import LinearProgress from '@smui/linear-progress';
    import Paper from '@smui/paper';
    import {onMount} from "svelte";
    import Textfield from '@smui/textfield';
    import {makeRequest} from "./functions";
    import {UPLOAD_METHOD} from "./constants";


    // setup - does not change
    let bodyDisabled = false;
    let workInProcess = false;
    let longerWorkInProcess = false;

    let snackBar;
    let snackBarMsg;
    let snackBarTimeout = -1;

    const showSnackMessage = async (msg, timeout = 4.0) => {
        snackBarMsg = msg;
        if (timeout !== -1) {
            snackBarTimeout = Math.ceil(Math.max(timeout, 4) * 1000);
        }
        snackBar.open();
    }
    const togglePageState = (state) => {
        if (state === undefined || state !== true || state !== false) {
            bodyDisabled = !bodyDisabled;
            workInProcess = !workInProcess;
            longerWorkInProcess = !longerWorkInProcess;
        } else {
            bodyDisabled = state;
            workInProcess = state;
            longerWorkInProcess = state;
        }
    }
    // define variables to use
    const themeColor = "#fff";

    const videoConstraints = {
        facingMode: {ideal: "environment"},
        width: {
            // ideal: 4032,
            ideal: 3264,
        },
        height: {
            // ideal: 3024,
            ideal: 2448,
        },
        focusMode: {ideal: "auto"}
    };

    let canvas;
    let stream;
    let video;

    let inputFieldRef;
    let inputField = "";

    let errorAudio;
    let successAudio;


    onMount(async () => {
        togglePageState(false);
        navigator.mediaDevices.getUserMedia(
            {
                "video": videoConstraints,
                "audio": false,
            }
        )
            .then((videoStream) => {
                stream = videoStream;
                video.srcObject = stream;
            });
        video.addEventListener('canplay', () => {
            canvas.height = video.videoHeight;
            canvas.width = video.videoWidth;
            showSnackMessage(`Canvas size is set to ${canvas.height}x${canvas.width}.`)
        })
        togglePageState(true);
        inputFieldRef.focus();
    })

    const handleInputSubmit = async (event) => {
        event.preventDefault();

        const value = inputField;

        if (value.length <= 0) {
            await showSnackMessage("Please scan something first.")
            return false;
        } else {
            inputField = "";
        }

        await showSnackMessage(`Clicking image for: ${value}`, 0.5);

        canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);

        if (UPLOAD_METHOD === "blob") {
            canvas.toBlob(
                async (blob) => {
                    await showSnackMessage(`Submitting with: ${value}`, 0.5);
                    togglePageState(false);

                    try {
                        const {ok, msg} = await makeRequest(
                            "submit-blob" + "?" + new URLSearchParams({"qr": value}).toString(),
                            "POST",
                            blob,
                        );
                        togglePageState(true);
                        inputFieldRef.focus();

                        if (ok === true) {
                            await showSnackMessage(msg);
                            successAudio.play();
                            inputFieldRef.focus();
                        } else {
                            await showSnackMessage(msg);
                            errorAudio.play();
                            inputFieldRef.focus();
                        }
                    } catch (e) {
                        console.error(e);
                        await showSnackMessage(`Failed to process. Please reload or contact developer.`, -1);
                    }
                }, "image/jpeg"
            );
        } else if (UPLOAD_METHOD === "data-url") {
            try {
                let data = new FormData();
                data.append("qr", value);
                data.append("image", canvas.toDataURL("image/jpeg"));

                await showSnackMessage(`Submitting with: ${value}`, 0.5);
                togglePageState(false);
                                const {ok, msg} = await makeRequest(
                    "submit",
                    "POST",
                    data,
                );
                togglePageState(true);
                inputFieldRef.focus();

                if (ok === true) {
                    await showSnackMessage(msg);
                    successAudio.play();
                    inputFieldRef.focus();
                } else {
                    await showSnackMessage(msg);
                    errorAudio.play();
                    inputFieldRef.focus();
                }
            } catch (e) {
                console.error(e);
                await showSnackMessage(`Failed to process. Please reload or contact developer.`, -1);
            }
        } else {
            await showSnackMessage(`Failed to process [INVALID MODE]. Please reload or contact developer.`, -1);
        }

        inputFieldRef.focus();
    }

</script>

<section style="padding: 0;">
    {#if workInProcess}
        <LinearProgress indeterminate/>
        {#if longerWorkInProcess}
            <div style="display: flex;justify-content: center;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 99;">
                <CircularProgress style="height: 10vh; width: 10vh;" indeterminate/>
            </div>
        {/if}
    {/if}


    <!-- snackbar logic starts -->
    <Snackbar bind:this={snackBar} labelText={snackBarMsg} timeoutMs={snackBarTimeout}>
        <SnackbarLabel/>
        {#if snackBarTimeout !== -1}
            <SnackbarActions>
                <IconButton class="material-icons" title="Dismiss">close</IconButton>
            </SnackbarActions>
        {/if}
    </Snackbar>
    <!-- snackbar logic ends -->

    <!-- body logic starts -->
    <Paper disable square elevation=0 class="paper-main {bodyDisabled || workInProcess ? 'paper-disable' : ''}"
           style="background-color: {themeColor};">
        <form novalidate autoComplete="off"
              on:submit={handleInputSubmit}>
            <Textfield
                    bind:this={inputFieldRef}
                    style="width: 100%;margin: 0.75vh 0.5vw 0.75vh 0.5vw;"
                    class="shaped-outlined"
                    variant="outlined"
                    disabled={bodyDisabled || workInProcess}
                    bind:value={inputField}
            >
            </Textfield>
        </form>
        <video id="video" bind:this={video} autoplay></video>
        <canvas id="canvas" bind:this={canvas}></canvas>
        <audio src="/static/error.wav" bind:this={errorAudio}></audio>
        <audio src="/static/success.wav" bind:this={successAudio}></audio>
    </Paper>
    <!-- body logic ends -->


</section>


<style>
    #video {
        width: 100%;
        height: 100%;
    }

    #canvas {
        display: none;
    }

    * :global(.paper-disable) {
        z-index: 1000;
        opacity: .5;
        pointer-events: none;
    }

    * :global(.paper-main) {
        margin: 0 auto;
        max-width: 80%;
    }

    * :global(.main-select-width) {
        min-width: 250px;
    }

    * :global(.shaped-outlined .mdc-text-field__input) {
        padding-left: 32px;
        padding-right: 0;
    }

    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__leading) {
        border-radius: 28px 0 0 28px;
        width: 28px;
    }

    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__trailing) {
        border-radius: 0 28px 28px 0;
    }

    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__notch) {
        max-width: calc(100% - 28px * 2);
    }

    * :global(.shaped-outlined + .mdc-text-field-helper-line) {
        padding-left: 32px;
        padding-right: 28px;
    }

    *:global(.shaped-outlined
      .mdc-notched-outline
      .mdc-notched-outline__leading) {
        border-radius: 28px 0 0 28px;
        width: 28px;
    }

    *:global(.shaped-outlined
      .mdc-notched-outline
      .mdc-notched-outline__trailing) {
        border-radius: 0 28px 28px 0;
    }

    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__notch) {
        max-width: calc(100% - 28px * 2);
    }

    *:global(.shaped-outlined.mdc-text-field--with-leading-icon:not(.mdc-text-field--label-floating)
      .mdc-floating-label) {
        left: 16px;
    }

    * :global(.shaped-outlined + .mdc-text-field-helper-line) {
        padding-left: 32px;
        padding-right: 28px;
    }

    * :global(.mdc-layout-grid__inner) {
        grid-gap: 4px;
    }

</style>
